import { render, staticRenderFns } from "./VideoWithContent.vue?vue&type=template&id=0a360e9c"
import script from "./VideoWithContent.vue?vue&type=script&lang=js"
export * from "./VideoWithContent.vue?vue&type=script&lang=js"
import style0 from "./VideoWithContent.vue?vue&type=style&index=0&id=0a360e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports